import { Link } from "react-router-dom";

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  return (
    <footer className='footer font-poppins'>
      <hr className='border-slate-200' />

      <div className='footer-container'>
        <p>
          © 2024 <strong>DawletKenesbaev</strong>. All rights reserved.
        </p>

        <div className='flex gap-3 justify-center items-center'>
              <a target="_blank" href="https://www.linkedin.com/in/dawlet-kenesbaev-1744b028b/"><LinkedInIcon className="icon"/></a>
              <a target="_blank" href="https://github.com/DawletKenesbaev"><GitHubIcon className="icon" /></a>
              <a target="_blank" href="https://t.me/TheUbermensch1"><TelegramIcon className="icon"/></a>
              <a target="_blank" href="mailto:devdawlet@gmail.com"><EmailIcon className="icon"/></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
